const ProductData =[
    {
        productTitle:'Grass Cutter',
        productPrice:'35,500.00',
        productImage:'../product-image/Grass-Cutter.png',
    },
    {
        productTitle:'Animal Loader Scale',
        productPrice:'75,500.00',
        productImage:'../product-image/Loader-Scale.png',
    },
    {
        productTitle:'Weight Machine',
        productPrice:'4,500.00',
        productImage:'../product-image/Weight-Scale.png',
    },
    {
        productTitle:'Animal-Mattress',
        productPrice:'10,500.00',
        productImage:'../product-image/Animal-Mattress.png',
    },
    {
        productTitle:'Animal Room Tube Light',
        productPrice:'5,000.00',
        productImage:'../product-image/tube-light.png',
    },
    {
        productTitle:'Sprayer-Machine',
        productPrice:'15,500.00',
        productImage:'../product-image/spare-machine2.png',
    }
    ,
    {
        productTitle:'Room Hitter',
        productPrice:'18,000.00',
        productImage:'../product-image/room-hitter.png',
    },
    {
        productTitle:'Milk Machine',
        productPrice:'25,000.00',
        productImage:'../product-image/Milking-Machine-02.png',
    }
]
export default ProductData;